import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { createFFmpeg, fetchFile } from '@ffmpeg/ffmpeg';
// import { OfflineCompiler } from "mind-ar/src/image-target/offline-compiler";
// import { loadImage } from 'canvas';
import { useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { MdDeleteForever } from "react-icons/md";
import Compressor from 'compressorjs';



///
import { LoginData } from "../../../redux/featuer/user/userSlice";
import PageChange from '../../../pageChange/index'
import Layout from "../../../component/Layout/Layout";
import Card from "../../../component/Layout/theme/card";
import { GetMethod } from "../../../helper/Api";
import { Input } from "../../../component/form/input";
import { Fragment } from "react";
import toast from "react-hot-toast";




function NewOrder() {

    const dispatch = useDispatch();
    const { token, login, user, language } = useSelector((item) => item.user);

    const [progress, setProgress] = useState(0);
    const [progressConvert, setProgressConvert] = useState(0);

    const [show, setShow] = useState(true)
    const [showConvert, setShowConvert] = useState(true)

    const [fullName, setFullNames] = useState("")
    const [site, setSite] = useState("")
    const [hint, setHint] = useState("")
    const [instagramUsername, setInstagramUsername] = useState("")
    const [call, setCall] = useState("")

    // const [code, setCode] = useState('')
    const [isDataLoad, SetIsDataLoad] = useState(false);
    const [errorSub, setErrorSub] = useState()
    const [optionsCheck, setOptionsCheck] = useState(false)
    // Prices
    const [sumPrice, SetSumPrice] = useState(0);
    const [price, setPrice] = useState(0);
    // const [type, SetType] = useState(null);
    const [addPriceImage, setAddPriceImage] = useState(0)
    // var price = user.cost;
    let params = useParams();
    var { t } = useTranslation();


    ////video and images
    const [allPhoto, setAllPhoto] = useState([])
    const [allVideo, setAllVideo] = useState([])
    const [pictureName, setPictureName] = useState("");
    const [videoName, setVideoName] = useState("");

    /////
    const axiosInstance = axios.create({
        baseURL: `${process.env.REACT_APP_SERVER}`,
        timeout: 3000000 // only wait for 2s
    });

    var durationConvert = 0;

    const ffmpeg = createFFmpeg({
        progress: (e) => {
            if (e.duration) {
                durationConvert = e.duration
            }
            if (e.time) {
                var fin = Math.round(((e.time + durationConvert) / durationConvert * 100) - 100)
                setProgressConvert(fin)
                setTimeout(() => {
                    document.getElementById("progressBarConvert").style.width = fin.toString() + "%";
                }, 100);
            }
        },
        log: true,
    });
    /////





    useEffect(() => {
        document.title = t("create_augmented_reality");
        if (login === false) {
            window.location.href = "/login"
        }
        getUser()
        getPrice(params.id)
    }, [])


    ///getUser
    const getUser = async () => {
        var url = `/api/user/me/`;

        const res = await GetMethod({ url: url, token: token })

        if (res.status === "success") {
            SetIsDataLoad(true);
            dispatch(LoginData(res.data));
        }

    }



    const getPrice = async (params) => {
        var url = `/api/setting/${params}`;

        const res = await GetMethod({ url: url, token: token, lan: language })

        if (res.status === "success") {
            setPrice(res.data.price)
            setAddPriceImage(res.data.addImages)
        }

    }


    const compiler = new window.MINDAR.IMAGE.Compiler();
    const loadImage = useCallback(async (file) => {
        return new Promise((resolve, reject) => {
            let img = new Image()
            img.onload = () => resolve(img);
            img.onerror = reject;
            img.src = URL.createObjectURL(file);
        })
    }, []);



    const startUpload = async (e) => {
        e.preventDefault();
        setShow(false)
        if (fullName === "" || fullName === null) {
            setShow(true)
            return toast.error(t("please_fill_name_validation"))
        }
        if (allPhoto.length === 0) {
            setShow(true)
            return toast.error(t("please_fill_picture_validation"));
        }

        document.getElementById("dropzone").disabled = true;
        document.getElementById("video").disabled = true;
        document.getElementById("nameTest").disabled = true;

        const images = [];
        for (let i = 0; i < allPhoto.length; i++) {
            images.push(await loadImage(allPhoto[i]));
        }

        await compiler.compileImageTargets(images, (progress) => {
            document.getElementById("progress").innerHTML =
                ` ${t("create_augmented_reality")} ` + Math.round(progress) + "%";
            // setPercentage(progress.toFixed(2));
        });
        // onDataReady(dataList, exportedBuffer);
        setTimeout(async () => {
            const exportedBuffer = await compiler.exportData();
            var blob = new Blob([exportedBuffer]);
            submitForm(blobToFile(blob, "targets.minogar"), allVideo)
        }, 2000);
    }

    function blobToFile(theBlob, fileName) {
        return new File([theBlob], fileName, { lastModified: new Date().getTime(), type: theBlob.type })
    }

    async function convertUserVideo(video) {
        await ffmpeg.load();
        ffmpeg.FS('writeFile', video.name, await fetchFile(video));
        await ffmpeg.run('-i', video.name, '-c:v', 'libx264', '-vf', 'scale=720:-2,format=yuv420p', '-c:a', 'copy', '-movflags', '+faststart', 'output.mp4');
        const data = ffmpeg.FS('readFile', 'output.mp4');
        const blob = new Blob([data.buffer], { type: 'video/mp4' })
        var file = blobToFile(blob, "final.mp4");
        return file;
    }




    const types = async (type) => {
        switch (type) {
            case "price_business":
                return 0
            case "price_free":
                return 1
            case "price_personal":
                return 2
            default:
                break;
        }
    }




    const submitForm = async (blobMind, videoNameConverted) => {

        // چک شود و عکس آپلود شود
        if (videoNameConverted.length !== 0) {
            var getTypes = await types(params.id)
            setProgress(1)
            const formData = new FormData();

            allPhoto.map((item) => {
                formData.append("image", new File([item], item.name, { lastModified: new Date().getTime(), type: item.type }));
            })

            videoNameConverted.map((item) => {
                formData.append("video", item);
            })

            formData.append("mind", blobMind);
            formData.append("name", fullName);

            formData.append("types", getTypes);

            if (site !== "") {
                formData.append("site", site);
            }
            if (hint !== "") {
                formData.append("hint", hint);
            }
            if (instagramUsername !== "") {
                formData.append("instagram", instagramUsername);
            }
            if (call !== "") {
                formData.append("call", call);
            }


            await axiosInstance.post("/api/nft/", formData, {
                headers: {
                    // 'Content-Type': 'application/json',
                    Authorization: "ArNew " + token,
                },
                onUploadProgress: data => {
                    var percentComplete = Math.ceil((100 * data.loaded) / data.total);
                    setProgress(percentComplete)
                    document.getElementById("progressBar").style.width = percentComplete.toString() + "%";
                }
            })
                .then(
                    function (response) {
                        if (response.data.status === "success") {

                            if (typeof window !== 'undefined') {
                                if (response.data?.msg === "free") {
                                    window.location.href = `${process.env.REACT_APP_CLIENT}/qrcode/${response.data.data}`;
                                } else {
                                    window.location.href = `${process.env.REACT_APP_SERVER}/api/payment/${response.data.data}?authorization=${token}`;
                                }
                            }
                        } else {
                            toast.error(response?.data?.msg);
                        }
                    }
                ).catch(function ({ response }) {
                    if (response.status !== 200) {
                        toast.error(response?.data?.msg)
                    }
                });
        } else {
            setShow(true)
            toast.error("error");
        }
    };

    // زدن اینتر
    function enterKeyPress(e) {
        if (e.key === "Enter") {
            submitForm(e);
            startUpload(e);
            // discountCode(e)
        }
    }

    /////زخیره عکس ها 
    const saveAllImage = async () => {

        setShowConvert(false);
        var validate = true;

        if (pictureName.length <= 0) {
            validate = false
            toast.error(t("fill_in_image_validation"))
            setShowConvert(true);
            return validate
        }

        if (videoName.length <= 0) {
            validate = false
            toast.error(t("fill_in_video_validation"))
            setShowConvert(true);
            return validate
        }

        if (pictureName[0].size > 50000000) {
            validate = false
            toast.error(t("image_size_5mb_validation"))
            setShowConvert(true);
            return validate
        }

        if (videoName[0].size > 50000000) {
            validate = false
            toast.error(t("video_more_50_MB_validation"))
            setShowConvert(true);
            return validate
        }

        const videoConverted = await convertUserVideo(videoName[0]);
        // const videoConverted = videoName[0];
        setVideoName([videoConverted]);

        if (allPhoto.some(e => e.name === pictureName[0].name) === true) {
            validate = false
            toast.error(t("do_not_duplicate_photos_validation"))
            setPictureName("")
            setVideoName("")
            setShowConvert(true);
            return validate
        }

        if (params.id === "price_personal" && allPhoto.length > 0) {
            validate = false
            toast.error(t("you_cannot_multiple_photos_validation"))
            setPictureName("")
            setVideoName("")
            setShowConvert(true);
            return validate
        }
        await setAllPhoto(photo => [...photo, pictureName[0]])
        await setAllVideo(video => [...video, videoName[0]])

        if (allPhoto.length > 0) {
            setPrice(price + addPriceImage);
        }

        setPictureName("")
        setVideoName("")
        setShowConvert(true);
    }
    //delete images
    const deleteImage = async (image, video) => {
        setAllPhoto(oldValues => {
            return oldValues.filter(item => item.name !== image)
        })
        await setAllVideo(oldValueVideo => {
            return oldValueVideo.filter(items => items.name !== video)
        })
    }


    const [bodyWidth, setBodyWidth] = useState(null);


    useEffect(() => {
        const handleResize = () => {
            setBodyWidth(document.body.offsetWidth);
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleResize = (bodyWidth) => {
        if (bodyWidth < 1024) {
            return "max-w-screen-2xl  px-6 sm:px-8 lg:px-16 mx-auto";
        } else {
            return "w-max-w-screen-2xl  px-6 sm:px-8 lg:px-16 mx-auto rounded-lg"
        }
    };


    useEffect(() => {
        handleResize(bodyWidth)
    }, []);


    return (
        <>
            {isDataLoad ? (
                <>
                    <Layout />
                    <div className="flex flex-col gap-5 mb-24 lg:grid lg:grid-cols-2">

                        <div className="order-2 space-y-5 lg:order-1 ">
                            <Card className={handleResize(bodyWidth)} >
                                <div className="p-5 space-y-4 bg-white rounded-lg shadow-md " >
                                    <div className="text-gray-400 ">
                                        <p className="font-bold text-gray-500">{t("tip")}: </p>
                                        <p >{t("the_image_below_is_5mb")}  </p>
                                        <p>{t("the_video_below_is_50mb")}</p>
                                    </div>
                                    {/* /form images */}
                                    <label className="text-sm ">{t("your_photo")}</label>
                                    <div className="flex space-y-2 ">
                                        <label
                                            htmlFor="dropzone"
                                            className="w-full px-4 py-2 overflow-hidden text-gray-400 truncate rounded-md ring-1 ring-gray-300 max-h-10"
                                        >
                                            {pictureName.length !== 0
                                                ? pictureName[0].name
                                                : t("selection")}
                                        </label>
                                        <input
                                            multiple={false}
                                            type="file"
                                            id="dropzone"
                                            className="hidden truncate"
                                            placeholder="عکس"
                                            accept="image/png, image/jpeg"
                                            // onChange={(e) => checkImages(e)}
                                            onChange={async (e) => {
                                                new Compressor(e.target.files[0], {
                                                    quality: 0.6,
                                                    maxWidth: 900,
                                                    maxHeight: 900,
                                                    success: (compressedResult) => {
                                                        setPictureName([compressedResult])
                                                    },
                                                });
                                            }}

                                        />
                                    </div>
                                    {/* /form videos */}
                                    <label className="text-sm ">{t("your_video")}</label>
                                    <div className="space-y-2 flex w-[100%] ">
                                        <label
                                            htmlFor="video"
                                            className="w-full px-4 py-2 overflow-hidden text-gray-400 truncate rounded-md ring-1 ring-gray-300 max-h-10"
                                        >
                                            {videoName.length
                                                ? videoName[0].name
                                                : t("selection")}
                                        </label>
                                        <input
                                            multiple={false}
                                            type="file"
                                            id="video"
                                            className="hidden truncate"
                                            // onChange={(e) => setVideoName(videoName => [...videoName, e.target.files[0]])}
                                            onChange={(e) => setVideoName(e.target.files)}
                                            placeholder="ویدیو"
                                            accept="video/mp4"
                                        />
                                    </div>


                                    {showConvert ? (
                                        <div className="relative flex rounded-lg ">
                                            <button onClick={() => saveAllImage()} className="w-full p-2 text-white bg-green-500 rounded-lg ">{t("add")}</button>
                                        </div>
                                    ) : (
                                        <div role="status">
                                            <svg className="inline w-6 h-6 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                            </svg>
                                            <span className="p-2">{t("convertVideo")}</span>
                                            <div className="my-4">
                                                {
                                                    progressConvert !== 0 && (
                                                        <div className="w-full mt-4 bg-gray-200 rounded-full dark:bg-gray-700">
                                                            <div id="progressBarConvert" className="bg-green-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full">{progressConvert}%</div>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                            <div className="flex flex-col justify-center h-10 text-center text-white bg-blue-100 rounded-lg">
                                                {t("add")}
                                            </div>
                                        </div>
                                    )}

                                    <p>
                                        {errorSub}
                                    </p>
                                </div>
                            </Card>

                            <Card className={handleResize(bodyWidth)}>
                                <div className="p-5 space-y-4 bg-white rounded-lg shadow-md">
                                    {/* /formName */}
                                    <div className="relative">
                                        <Input
                                            placeholder={t("names")}
                                            id="nameTest"
                                            onChange={(e) => setFullNames(e.target.value)}
                                        />
                                    </div>
                                    {/*  Options  */}
                                    {params.id === "price_personal" ? (
                                        ""
                                    ) :
                                        <div className="space-y-2 mt-6 flex w-[100%] cursor-pointer font-bold text-gray-500">
                                            <div onClick={() => setOptionsCheck(!optionsCheck)}>{optionsCheck ? `${t("fewer_settings")}` : `${t("more_settings")}`}</div>
                                        </div>
                                    }
                                    {optionsCheck && (
                                        <>
                                            <div className="relative mt-2 ">
                                                <Input
                                                    placeholder={t("site_link")}
                                                    id="site"
                                                    onChange={(e) => setSite(e.target.value)}
                                                />
                                            </div>
                                            <div className="relative mt-3">
                                                <Input
                                                    placeholder={t("help_site")}
                                                    id="hint"
                                                    onChange={(e) => setHint(e.target.value)}
                                                />
                                            </div>
                                            <div className="relative mt-3">
                                                <Input
                                                    placeholder={t("instagram_username")}
                                                    id="instagram"
                                                    onChange={(e) => setInstagramUsername(e.target.value)} />
                                            </div>
                                            <div className="relative mt-3">

                                                <Input
                                                    placeholder={t("phone_number")}
                                                    id="call"
                                                    onChange={(e) => setCall(e.target.value)} />
                                            </div>

                                        </>
                                    )}
                                    <div className="flex justify-between mt-2 ">
                                        <label className="flex items-center text-sm font-bold">  {t("price")}:</label>

                                        {
                                            sumPrice > 1
                                                ?
                                                (
                                                    <>
                                                        <label className="text-lg "><del className="text-red-500">{price.toLocaleString()}</del> <span className="grid text-lg">{sumPrice.toLocaleString()}</span></label>
                                                    </>
                                                ) :
                                                user.freeNft >= 0 && params.id === "price_free" ? (
                                                    <>
                                                        <label className="inline-flex items-center text-lg "> {t("free")} </label>
                                                    </>
                                                )
                                                    :
                                                    (
                                                        <>
                                                            <label className="inline-flex items-center text-lg "> {price.toLocaleString()} <span className="mr-1 -mt-1 text-xs">{t("toman")}</span> </label>
                                                        </>
                                                    )
                                        }

                                    </div>


                                    {
                                        show === true
                                            ?
                                            (
                                                <>
                                                    {
                                                        params.id === "price_free" && user.freeNft === 0
                                                            ?
                                                            (
                                                                <button
                                                                    className="h-10 mt-2 text-white bg-blue-200 rounded-lg"
                                                                    disabled={true}
                                                                >
                                                                    {t("send")}
                                                                </button>
                                                            )
                                                            :
                                                            (
                                                                <button
                                                                    className="w-full h-10 mt-2 text-white bg-blue-500 rounded-lg"
                                                                    type="submit"
                                                                    onClick={startUpload}
                                                                    onKeyPress={(e) => enterKeyPress(e)}
                                                                >
                                                                    {t("send")}
                                                                </button>
                                                            )
                                                    }
                                                </>
                                            )
                                            :
                                            <>
                                                <div role="status">
                                                    <svg className="inline w-6 h-6 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                                    </svg>
                                                    <span className="p-2">{t("uploading")}</span>
                                                    <div className="my-4">
                                                        <span id="progress" className="text-center" dir="rtl"></span>
                                                        {
                                                            progress !== 0 && (
                                                                <div className="w-full mt-4 bg-gray-200 rounded-full dark:bg-gray-700">
                                                                    <div id="progressBar" className="bg-green-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full">{progress}%</div>
                                                                </div>
                                                            )}
                                                    </div>
                                                    <div
                                                        className="flex flex-col justify-center h-10 text-center text-white bg-blue-100 rounded-lg"
                                                    >
                                                        {t("send")}

                                                    </div>
                                                </div>
                                            </>
                                    }
                                </div>
                            </Card>
                        </div>

                        {/* /add images and videos */}
                        <Card className={`${handleResize(bodyWidth)} order-1 lg:order-2 w-full`}>
                            <div className="p-5 space-y-4 bg-white rounded-lg shadow-md">
                                <div className="text-sm font-bold text-center">
                                    <p>{t("your_video_photos")}</p>
                                </div>
                                {
                                    allPhoto.length > 0 && allPhoto.map((item, index) => {
                                        return (
                                            <Fragment key={index}>
                                                <div className="flex flex-col items-center gap-3 ">
                                                    <div className="flex flex-col items-center w-full overflow-hidden truncate ">
                                                        <span className="p-2 text-sm font-medium text-gray-400 truncate"> {t("image")} :</span>
                                                        <p className="text-sm font-light ">{item.name}</p>
                                                    </div>

                                                    <div className="flex flex-col items-center w-full overflow-hidden truncate ">
                                                        <span className="p-2 text-sm font-medium text-gray-400">{t("video")} :</span>
                                                        <p className="text-sm font-light truncate ">{allVideo[index] && allVideo[index].name}</p>
                                                    </div>

                                                    <MdDeleteForever className="cursor-pointer" color={"red"} size={25} onClick={() => deleteImage(item.name, allVideo[index].name)} />
                                                </div>
                                                <hr className="py-2 " />
                                            </Fragment>
                                        )
                                    })
                                }
                            </div>
                        </Card>
                    </div>


                </>
            ) : (
                <PageChange />
            )
            }
        </>
    );
}

export default NewOrder;

